import styled from 'styled-components';
import { pxToRem } from '../../../foundation/spacing/utils.js';

var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1uw63q7-0"
})(["display:flex;flex-direction:column;max-width:inherit;gap:", " 0;text-decoration:none;"], function (_ref) {
  var $dense = _ref.$dense;
  return $dense ? pxToRem(2) : '0';
});

export { Container };
